var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSells(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10049_969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12C4.81331 12 3.65328 11.6481 2.66658 10.9888C1.67989 10.3295 0.910851 9.39246 0.456725 8.2961C0.00259969 7.19975 -0.11622 5.99335 0.115291 4.82946C0.346802 3.66557 0.918247 2.59648 1.75736 1.75736C2.59648 0.918247 3.66557 0.346802 4.82946 0.115291C5.99335 -0.116221 7.19974 0.00259933 8.2961 0.456725C9.39246 0.910851 10.3295 1.67989 10.9888 2.66658C11.6481 3.65328 12 4.81331 12 6C12 7.5913 11.3679 9.11742 10.2426 10.2426C9.11742 11.3679 7.5913 12 6 12ZM9 6.16125C8.89979 6.06322 8.76518 6.00833 8.625 6.00833C8.48482 6.00833 8.35021 6.06322 8.25 6.16125L6.525 7.875V2.5725C6.525 2.43326 6.46969 2.29973 6.37123 2.20127C6.27278 2.10281 6.13924 2.0475 6 2.0475C5.86076 2.0475 5.72723 2.10281 5.62877 2.20127C5.53031 2.29973 5.475 2.43326 5.475 2.5725V7.8225L3.81375 6.16125C3.7143 6.0618 3.5794 6.00592 3.43875 6.00592C3.2981 6.00592 3.16321 6.0618 3.06375 6.16125C2.9643 6.26071 2.90842 6.3956 2.90842 6.53625C2.90842 6.6769 2.9643 6.8118 3.06375 6.91125L6.03 9.8625L9 6.90375C9.04876 6.855 9.08743 6.79712 9.11382 6.73342C9.14021 6.66972 9.15379 6.60145 9.15379 6.5325C9.15379 6.46355 9.14021 6.39528 9.11382 6.33158C9.08743 6.26788 9.04876 6.21 9 6.16125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10049_969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSells);
export default __webpack_public_path__ + "static/media/sells.8528bcb175fc9744421c9c309c41099b.svg";
export { ForwardRef as ReactComponent };